import React from 'react';

const DeleteInfo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#FEA50A" />
    <path
      d="M12.3848 16.292C11.5125 16.292 10.7812 17.0233 10.7812 17.8956C10.7812 18.768 11.5125 19.4992 12.3848 19.4992C13.2251 19.4992 13.9884 18.768 13.95 17.9341C13.9884 17.0168 13.2636 16.292 12.3848 16.292Z"
      fill="white"
    />
    <path
      d="M11.987 4.16704C11.2237 4.38513 10.749 5.07788 10.749 5.91817C10.7875 6.4249 10.8196 6.93806 10.8581 7.44479C10.9671 9.37553 11.0762 11.2678 11.1852 13.1985C11.2237 13.8528 11.7304 14.3274 12.3847 14.3274C13.039 14.3274 13.5521 13.8207 13.5842 13.16C13.5842 12.7623 13.5842 12.3967 13.6227 11.9926C13.6932 10.7546 13.7702 9.51664 13.8408 8.27866C13.8792 7.47686 13.9498 6.67507 13.9883 5.87327C13.9883 5.58462 13.9498 5.32804 13.8408 5.07147C13.5136 4.35305 12.7503 3.98743 11.987 4.16704Z"
      fill="white"
    />
  </svg>
);

export default DeleteInfo;
